import Web3 from 'web3';
import { EBlockchain } from 'multirpc-sdk';

import { IS_PROD } from 'modules/common/constants/env';

import { ETH_HOLESKY_RPC_URL, ETH_RPC_URL } from '../constants';
import { getRpcUrlByNetwork } from './getRpcUrlByNetwork';

export const getWeb3EthRpcUrl = () =>
  IS_PROD ? ETH_RPC_URL : ETH_HOLESKY_RPC_URL;

export const getWeb3Instance = (network = EBlockchain.eth) => {
  const rpcUrl = getRpcUrlByNetwork(network);

  return new Web3(rpcUrl);
};
